import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["transitionName", "routes"]),
    currentRouteName() {
      return this.$route.name;
    },
    getAllRoutes() {
      return this.routes;
    },
    previousRoute() {
      let idx = this.getAllRoutes.indexOf(this.currentRouteName);
      if (idx === 0) return false;
      return this.getAllRoutes[idx - 1];
    },
    nextRoute() {
      let total = this.getAllRoutes.length - 1;
      let idx = this.getAllRoutes.indexOf(this.currentRouteName);
      if (idx >= total) return false;
      return this.getAllRoutes[idx + 1];
    }
  },
  methods: {
    goToPreviousRoute() {
      this.transitionName = "previous";
      if (!this.previousRoute) return;
      this.$router.push({ name: this.previousRoute });
      window.scrollTo(0, 0);
    },
    goToNextRoute() {
      this.transitionName = "next";
      if (!this.nextRoute) return;
      this.$router.push({ name: this.nextRoute });
      window.scrollTo(0, 0);
    },
    setAllRoutes() {
      this.routes = this.$router.options.routes.map(item => {
        return item.name;
      });
    }
  }
};
